import axios from 'axios';
import { getApiUrl } from '../../config/api';
import { format } from 'date-fns';

export default class GrupousViewController {
  constructor() {
    this.grupous = [];
    this.loading = false;
    this.error = null;
    this.sortField = null;
    this.sortDirection = 'asc';
    this.currentPage = 1;
    this.itemsPerPage = 10;
  }

  // Inicializar el controlador
  initialize() {
    this.loadGrupous();
  }

  // Cargar lista de grupos
  async loadGrupous() {
    this.loading = true;
    this.error = null;
    
    try {
      const response = await axios.post(getApiUrl('/api/Grupou/listar'), {});
      this.grupous = response.data || [];
    } catch (error) {
      console.error('Error al cargar grupos:', error);
      this.error = 'No se pudieron cargar los grupos. Por favor, intente nuevamente.';
    } finally {
      this.loading = false;
    }
  }

  // Recargar lista de grupos
  async reloadGrupous() {
    await this.loadGrupous();
  }

  // Eliminar grupo
  async deleteGrupou(grupouCode) {
    try {
      const response = await axios.post(getApiUrl('/api/Grupou/borrar'), { GrupouCode: grupouCode });
      return response;
    } catch (error) {
      console.error('Error al eliminar grupo:', error);
      throw error;
    }
  }

  // Ordenar datos
  sort(field) {
    if (this.sortField === field) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortField = field;
      this.sortDirection = 'asc';
    }
  }

  // Obtener icono de ordenamiento
  sortIcon(field) {
    if (this.sortField !== field) {
      return 'bi bi-arrow-down-up';
    }
    return this.sortDirection === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down';
  }

  // Obtener datos ordenados
  get sortedData() {
    if (!this.sortField) {
      return this.grupous;
    }

    return [...this.grupous].sort((a, b) => {
      let aVal = a[this.sortField];
      let bVal = b[this.sortField];

      // Manejar fechas
      if (this.sortField === 'FechaCreacion') {
        aVal = new Date(aVal);
        bVal = new Date(bVal);
      }

      // Manejar strings
      if (typeof aVal === 'string') {
        aVal = aVal.toLowerCase();
        bVal = bVal.toLowerCase();
      }

      if (aVal < bVal) {
        return this.sortDirection === 'asc' ? -1 : 1;
      }
      if (aVal > bVal) {
        return this.sortDirection === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }

  // Obtener datos paginados
  get paginatedData() {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    return this.sortedData.slice(start, end);
  }

  // Obtener número total de páginas
  get totalPages() {
    return Math.ceil(this.grupous.length / this.itemsPerPage);
  }

  // Formatear fecha
  formatDate(date) {
    return format(new Date(date), 'dd/MM/yyyy HH:mm');
  }

  // Getters para el estado
  getGrupous() {
    return this.grupous;
  }

  isLoading() {
    return this.loading;
  }

  getCurrentError() {
    return this.error;
  }

  getPaginatedData() {
    return this.paginatedData;
  }

  getTotalPages() {
    return this.totalPages;
  }

  getCurrentPage() {
    return this.currentPage;
  }

  setCurrentPage(page) {
    this.currentPage = page;
  }
}